/**
 * Zod validation schemas for Orçamentos components
 */

import { z } from "zod";

/**
 * Budget Line Item Form Schema
 * Validates form data for creating/editing budget line items
 */
export const budgetLineItemSchema = z.object({
  name: z.string().min(1, "Nome do evento é obrigatório"),
  paymentDate: z.string().min(1, "Data de pagamento é obrigatória"),
  paymentMethod: z.string().min(1, "Forma de pagamento é obrigatória"),
  value: z.number().positive("Valor deve ser maior que zero"),
  status: z.string().min(1, "Status é obrigatório"),
  lastApprovedBudget: z.number().nonnegative("Orçamento aprovado não pode ser negativo"),
  attachments: z.instanceof(File).optional().nullable(),
  fiscalDocType: z.string().nullable(),
  fiscalDocNumber: z.string().nullable(),
  fiscal_note_url: z.string().url().nullable().optional(),
});

export type BudgetLineItemFormData = z.infer<typeof budgetLineItemSchema>;

/**
 * Budget Sub-item Form Schema
 * Validates form data for creating/editing budget sub-items (Topics)
 */
export const budgetSubitemSchema = z.object({
  phaseId: z.string().min(1, "Fase é obrigatória"),
  name: z.string().min(1, "Descrição do sub-item é obrigatória"),
  value: z.number().nonnegative("Valor não pode ser negativo"),
});

export type BudgetSubitemFormData = z.infer<typeof budgetSubitemSchema>;
